'use client';

import { useUser } from '@auth0/nextjs-auth0/client';
import SplitIO from '@splitsoftware/splitio/types/splitio';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { ReactNode, useEffect, useState } from 'react';
import { CenteredLoadingSpinner } from '@bss-portfolio-view-ui/shared-common-ui-loading-spinner';

type FeatureFlagsProviderProps = {
  children?: ReactNode;
  authorizationKey: string;
  customerIdentifier: string;
  features: SplitIO.MockedFeaturesMap;
};

export function FeatureFlagsProvider(props: FeatureFlagsProviderProps) {
  const { children, customerIdentifier, authorizationKey, features } = props;
  const { user, isLoading } = useUser();
  const [splitConfig, setSplitConfig] = useState<SplitIO.IBrowserSettings>(() => {
    return {
      // This is mock for feature flags
      features,
      core: {
        // This has to set to `localhost` to make the feature flags mock work
        authorizationKey: authorizationKey,
        key: user?.email ?? customerIdentifier,
      },
    };
  });

  useEffect(() => {
    setSplitConfig((prevConfig) => ({
      ...prevConfig,
      core: { ...prevConfig.core, key: user?.email ?? customerIdentifier },
    }));
  }, [customerIdentifier, user]);

  if (isLoading) {
    return <CenteredLoadingSpinner />;
  }

  return <SplitFactoryProvider config={splitConfig}>{children}</SplitFactoryProvider>;
}
